<div class="request-menu">
  <div class="request-menu__left">
    <div class="input-group"
         [formGroup]="searchForm">
      <input type="text"
             class="form-control"
             formControlName="searchRequest"
             placeholder="{{'components.menuBarComponent.searchButton.placeholder' | translate}}">


      <span *ngIf="!isSearchTextEmpty"
            class="input-group-addon search-reset"
            (click)="onResetSearch()">
        <span class="fa fa-times-circle"></span>
      </span>

      <span class="input-group-addon search-button"
            (click)="onSearchRequest()">
        <span class="fa fa-search align-middle"></span>
      </span>

    </div>
    <div class="btn-map-list">
      <button type="button"
              [ngClass]="sharedButtonClass"
              class="btn btn-default btn-icon"
              (click)="onClickBtn(requestListType.BOTH)">
        <span class="fa fa-adjust"></span>
        <span class="lbl">{{'components.requestMenuComponent.shared' | translate}}</span>
      </button>

      <button type="button"
              [ngClass]="mapOnlyButtonClass"
              class="btn btn-default btn-icon"
              (click)="onClickBtn(requestListType.MAP)">
        <span class="fa fa-map-o"></span>
        <span class="lbl">{{'components.requestMenuComponent.map' | translate}}</span>
      </button>

      <button type="button"
              [ngClass]="listOnlyButtonClass"
              class="btn btn-default btn-icon"
              (click)="onClickBtn(requestListType.LIST)">
        <span class="fa fa-list-ul"></span>
        <span class="lbl">{{'components.requestMenuComponent.list' | translate}}</span>
      </button>
    </div>
  </div>
  <div class="request-menu__right">
    <button type="button"
            class="btn btn-default btn-icon"
            (click)="onRefresh()">
      <span class="fa fa-refresh"></span>
      <span class="lbl">{{'components.requestMenuComponent.refresh' | translate}}</span>
    </button>

    <button type="button"
            *ngIf="false"
            class="btn btn-default btn-on-off"
            (click)="onClickBtn('toggle')"
            disabled>
      <span class="fa fa-toggle-on"></span>
    </button>

    <button type="button"
            class="btn btn-default btn-icon"
            (click)="open()"
            [disabled]="alertsCount === 0">
      <span class="fa fa-bell-o"></span>
      <span class="lbl">{{'components.requestMenuComponent.alerts' | translate}}</span>
      <span class="badge" *ngIf="alertsCount > 0">{{alertsCount}}</span>
    </button>

    <app-request-alert [title]='"Some standard title"'
                         [enableModal]="enableModal"
                         [showClose]='true'
                         (closeEvent)="close()"
                         (showModal)="onEnableModal($event)"
                         #editModal>{{ bindModal(editModal) }}
    </app-request-alert>

  </div>
</div>
